import React, { useEffect } from "react";

//contexts
import { UserProvider } from "state/user/userContext";
import { GlobalProvider } from "state/global/globalContext";
import { LocationProvider } from "state/location/locationContext";
import { GatewayProvider } from "state/gateway/gatewayContext";

//Router
import { BrowserRouter as Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import AppRoutes from "router";

//components
import { useReactPWAInstall } from "components/shared/Pwa/src";

//Style
import "../../theme/main.scss";

//const
const history = createBrowserHistory();

function App() {
    const { pwaInstall, supported, isInstalled } = useReactPWAInstall();
    useEffect(() => {
        const appInstalledStatus = localStorage.getItem("AppInstalled");

        appInstalledStatus !== "canceled" &&
            !isInstalled() &&
            pwaInstall({
                title: "نصب اپلیکیشن فراپال",
                logo: "assets/images/logo.png",
                features: (
                    <ul>
                        <li>ایجاد درگاه اختصاصی</li>
                        <li>ساخت فاکتور اختصاصی</li>
                    </ul>
                ),
                description: "ارائه دهنده درگاه پرداخت آنلاین ",
            })
                .then(() => {
                    console.log("App installed successfully or the install instruction was shown");
                })
                .catch(() => {
                    console.log("App not installed, user opted out. ");
                    localStorage.setItem("AppInstalled", "canceled");
                });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Router history={history} >
            <GlobalProvider>
                <UserProvider>
                    <LocationProvider>
                        <GatewayProvider>
                            <AppRoutes />
                        </GatewayProvider>
                    </LocationProvider>
                </UserProvider>
            </GlobalProvider>
        </Router>
    );
}

export default App;
